import React from "react";
import "./Groups.css";
import PaginationTable from "../../components/paginationTable/PaginationTable";
import { textFilter } from "react-bootstrap-table2-filter";
import CamplaCoreService from "../../services/CamplaCoreService";
import CreateGroupDialog from "./dialogs/createGroupDialog/CreateGroupDialog";
import Button from "react-bootstrap/Button";
import UpdateGroupDialog from "../groups/dialogs/updateGroupDialog/UpdateGroupDialog";
import UnsavedChangesDialog from "../../components/dialogs/unsavedChangesDialog/UnsavedChangesDialog";
import ShowMembersDialog from "./dialogs/showMembersDialog/showMembersDialog";
import ClassActionCell from "../classes/classActionCell/ClassActionCell";
import StorageService from "../../services/StorageService";
import APIErrorHelper from "../../helpers/APIErrorHelper";
import {
  ButtonGroup,
  Col,
  Container,
  Row,
  Spinner,
  ToggleButton,
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faPlus } from "@fortawesome/free-solid-svg-icons";
import DeleteDialog from "../../components/dialogs/deleteDialog/DeleteDialog";
import PaginationTableFilterToggle from "../../components/paginationTableFilterToggle/PaginationTableFilterToggle";

class Groups extends React.Component {
  tableId = "groupsTable";

  constructor(props) {
    super(props);
    let showFilters = StorageService.tableConfigShowFilters(this.tableId);
    this.state = {
      groups: [],
      users: [],
      userMap: new Map(),
      userGroupsMap: new Map(),
      showCreateClassModal: false,
      showDeleteSelectedClassesModal: false,
      showDeleteSingleGroupModal: false,
      showUpdateGroupModal: false,
      showMembersModal: false,
      showUnsavedChangesDialog: false,
      closeAction: () => {},
      groupToDeleteOrEdit: null,
      displayFilter: showFilters ? "initial" : "none",
      showFilters,
      dialogApiError: "",
      apiError: "",
      isDeleting: false,
      isUpdating: false,
      memberCount: 0,
    };

    this.handleCreateGroup = this.handleCreateGroup.bind(this);
    this.handleUpdateGroup = this.handleUpdateGroup.bind(this);
    this.handleDeleteGroup = this.handleDeleteGroup.bind(this);
    this.handleOnDelete = this.handleOnDelete.bind(this);
    this.addUsergroupMaps = this.addUsergroupMaps.bind(this);
    this.handleCountMember = this.handleCountMember.bind(this);
  }

  async componentDidMount() {
    this.paginationTableRef = React.createRef();

    try {
      let groups = StorageService.getReferenceType("groups");
      let usergroups = StorageService.getReferenceType("usergroups");
      let users = StorageService.getReferenceType("users");

      if (groups) {
        this.setState({ groups: groups });
      }

      if (users) {
        this.setState({ users });
      }

      let userMap = new Map();
      let userGroupsMap = new Map();

      if (users && usergroups && groups) {
        users.forEach((user) => {
          userMap.set(user._id, user);
        });

        groups.forEach((group) => userGroupsMap.set(group._id, []));

        usergroups.forEach((userGroup) => {
          const members = userGroupsMap.get(userGroup.groupId);
          const user = userMap.get(userGroup.userId);
          members.push(user);
          userGroupsMap.set(userGroup.groupId, members);
        });

        this.setState({ userMap, userGroupsMap });
      }

      groups = await CamplaCoreService.getAllGroups();
      StorageService.set("groups", groups);
      this.setState({ groups });

      users = await CamplaCoreService.getAllUsers();
      this.setState({ users });
      StorageService.set("users", users);
      usergroups = await CamplaCoreService.getUsergroups();
      StorageService.set("usergroups", usergroups);

      userMap = new Map();
      users.forEach((user) => {
        userMap.set(user._id, user);
      });

      userGroupsMap = new Map();
      groups.forEach((group) => userGroupsMap.set(group._id, []));

      usergroups.forEach((userGroup) => {
        const members = userGroupsMap.get(userGroup.groupId);
        const user = userMap.get(userGroup.userId);
        members.push(user);
        userGroupsMap.set(userGroup.groupId, members);
      });

      this.setState({ userMap, userGroupsMap });
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => {
            this.setState({ apiError: "" });
          },
          {},
          this.props.t
        ),
      });
    }
  }

  handleCountMember(count) {
    this.setState({ memberCount: count });
  }

  addUsergroupMaps(groupToCreate, createdGroup) {
    const newUserGroupsMap = new Map(this.state.userGroupsMap);
    newUserGroupsMap.set(createdGroup._id, []);

    groupToCreate.members.value.forEach((el) => {
      const members = newUserGroupsMap.get(createdGroup._id);
      const user = this.state.userMap.get(el.authenticatorUserId);
      members.push(user);
      newUserGroupsMap.set(createdGroup._id, members);
    });

    this.setState({ userGroupsMap: newUserGroupsMap }, () => {});
  }

  async handleCreateGroup(groupToCreate) {
    try {
      const createdGroup = await CamplaCoreService.createGroup(groupToCreate);
      this.state.groups.push(createdGroup);

      groupToCreate.members.forEach((el) => {
        const dict = { userId: el.userId, groupId: createdGroup._id };
        CamplaCoreService.createUsergroup(dict);
      });

      this.setState({
        showCreateClassModal: false,
        groups: Object.assign([], this.state.groups),
      });

      const newUserGroupsMap = new Map(this.state.userGroupsMap);
      newUserGroupsMap.set(createdGroup._id, []);
      groupToCreate.members.forEach((el) => {
        const members = newUserGroupsMap.get(createdGroup._id);
        const user = this.state.userMap.get(el.userId);
        members.push(user);
        newUserGroupsMap.set(createdGroup._id, members);
      });
      this.setState({ userGroupsMap: newUserGroupsMap }, () => {});
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => {
            this.setState({ dialogApiError: "" });
          },
          {
            PRECONDITION_FAILED: "Classes.APIError.PreconditionFailed",
          },
          this.props.t
        ),
      });
    }
  }

  async handleUpdateGroup(changedGroup) {
    const usergroups = await CamplaCoreService.getUsergroups();
    try {
      this.setState({ isUpdating: true });

      const updatedGroup = await CamplaCoreService.updateGroup(
        this.state.groupToDeleteOrEdit._id,
        changedGroup
      );

      const usergroups = await CamplaCoreService.getUsergroups();
      const newUsergroups = changedGroup.members;

      const filteredUsergroups = usergroups.filter(
        (usergroup) => usergroup.groupId === this.state.groupToDeleteOrEdit._id
      );

      for (const filteredUsergroup of filteredUsergroups) {
        let valid = false;
        for (const newUsergroup of newUsergroups) {
          if (filteredUsergroup.userId === newUsergroup.userId) {
            valid = true;
          }
        }
        if (!valid) {
          await CamplaCoreService.deleteUsergroup(filteredUsergroup._id);
        }
      }

      for (const newUsergroup of newUsergroups) {
        let valid = false;
        for (const filteredUsergroup of filteredUsergroups) {
          if (newUsergroup.userId === filteredUsergroup.userId) {
            valid = true;
          }
        }
        if (!valid) {
          const dict = {};
          dict.userId = newUsergroup.userId;
          dict.groupId = this.state.groupToDeleteOrEdit._id;
          await CamplaCoreService.createUsergroup(dict);
        }
      }

      if (this.state.userGroupsMap.has(this.state.groupToDeleteOrEdit._id)) {
        const newUsersInUsergroup = [];
        for (const cg of changedGroup.members) {
          const userOfUserMap = this.state.userMap.get(cg.userId);
          newUsersInUsergroup.push(userOfUserMap);
        }

        this.state.userGroupsMap.set(
          this.state.groupToDeleteOrEdit._id,
          newUsersInUsergroup
        );
      }

      let index = this.state.groups
        .map((c) => c._id)
        .indexOf(this.state.groupToDeleteOrEdit._id);
      if (index !== -1) {
        this.state.groups[index] = updatedGroup;
      }
      this.setState({
        showUpdateGroupModal: false,
        groups: Object.assign([], this.state.groups),
        groupToDeleteOrEdit: null,
        isUpdating: false,
      });
    } catch (err) {
      this.setState({
        isUpdating: false,
        dialogApiError: APIErrorHelper.getError(
          err,
          () => {
            this.setState({ dialogApiError: "" });
          },
          {
            PRECONDITION_FAILED: "Classes.APIError.PreconditionFailed",
            NOT_FOUND: "Classes.APIError.NotFound",
            CONFLICT: "Classes.APIError.DeleteConflict",
          },
          this.props.t
        ),
      });
    }
  }

  handleOnDelete(sClass) {
    this.setState({
      groupToDeleteOrEdit: sClass,
      showDeleteSingleGroupModal: true,
    });
  }

  async handleDeleteGroup() {
    this.setState({ isDeleting: true });

    try {
      await CamplaCoreService.deleteGroup(this.state.groupToDeleteOrEdit._id);

      if (this.state.userGroupsMap.has(this.state.groupToDeleteOrEdit._id)) {
        this.state.userGroupsMap.delete(this.state.groupToDeleteOrEdit._id);
      }

      const index = this.state.groups.findIndex(
        (obj) => obj._id === this.state.groupToDeleteOrEdit._id
      );
      if (index !== -1) {
        const newGroups = this.state.groups.filter(
          (obj) => obj._id !== this.state.groupToDeleteOrEdit._id
        );
        this.setState(
          {
            groups: newGroups,
            showDeleteSingleGroupModal: false,
            groupToDeleteOrEdit: null,
            isDeleting: false,
          },
          () => {}
        );
      }
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => {
            this.setState({ dialogApiError: "" });
          },
          {
            PRECONDITION_FAILED: "Classes.APIError.PreconditionFailed",
            NOT_FOUND: "Classes.APIError.NotFound",
            CONFLICT: "Classes.APIError.DeleteConflict",
          },
          this.props.t
        ),
        isDeleting: false,
      });
    }
  }

  render() {
    const { t } = this.props;

    const memberData = {
      count: Date.now(),
    };

    const columns = [
      {
        dataField: "name",
        text: t("Groups.ColumnName"),
        sort: true,
        filter: textFilter({
          placeholder: t("Groups.FilterNamePlaceholder"),
          style: { width: "auto", display: this.state.displayFilter },
        }),
      },
      {
        dataField: "description",
        text: t("Groups.ColumnDescription"),
        sort: true,
        filter: textFilter({
          placeholder: t("Groups.FilterDescriptionPlaceholder"),
          style: { width: "auto", display: this.state.displayFilter },
        }),
        formatter: (cell, row) => {
          let string = cell.length > 40 ? cell.slice(0, 40) + "..." : cell;
          return <span> {string} </span>;
        },
      },
      {
        dataField: "members",
        text: t("Groups.ColumnMembercount"),
        formatExtraData: memberData,
        formatter: (cell, row, rowIndex, extraData) => {
          return (
            <span>
              {this.state.userGroupsMap.has(row._id)
                ? this.state.userGroupsMap.get(row._id).length
                : 0}
            </span>
          );
        },
      },
      {
        dataField: "actions",
        text: "",
        headerFormatter: () => (
            <PaginationTableFilterToggle
                onFilterToggle={(e) => {
                  this.setState({
                    showFilters: e.currentTarget.checked,
                    displayFilter: e.currentTarget.checked ? "initial" : "none",
                  });
                }}
                showFilters={this.state.showFilters}
                tableId={this.tableId} />
        ),
        headerClasses: "actionHeader",
        isDummyField: true,
        csvExport: false,
        formatter: (cell, sClass) => (
          <ClassActionCell
            onShowMembers={() => {
              this.setState({
                showMembersModal: true,
                groupToDeleteOrEdit: sClass,
              });
            }}
            onEdit={() => {
              this.setState({
                showUpdateGroupModal: true,
                groupToDeleteOrEdit: sClass,
              });
            }}
            onDelete={() => this.handleOnDelete(sClass)}
            class={sClass}
          />
        ),
      },
    ];

    return (
      <div>
        <CreateGroupDialog
          handleCountMember={this.handleCountMember}
          users={this.state.users}
          show={this.state.showCreateClassModal}
          dialogApiError={this.state.dialogApiError}
          onHide={(isFormDirty) => {
            if (isFormDirty) {
              this.setState({
                showUnsavedChangesDialog: true,
                closeAction: () =>
                  this.setState({
                    dialogApiError: null,
                    showCreateClassModal: false,
                  }),
              });
            } else {
              this.setState({
                dialogApiError: null,
                showCreateClassModal: false,
              });
            }
          }}
          onSubmit={this.handleCreateGroup}
        />

        <DeleteDialog
          show={this.state.showDeleteSingleGroupModal}
          dialogApiError={this.state.dialogApiError}
          onHide={() =>
            this.setState({
              dialogApiError: null,
              showDeleteSingleGroupModal: false,
            })
          }
          onSubmit={this.handleDeleteGroup}
          title={t("Groups.GroupModal.DeleteModal.Title")}
          body={
            <div style={this.state.isDeleting ? { textAlign: "center" } : {}}>
              {this.state.isDeleting ? (
                <Spinner animation="border" />
              ) : (
                t("Groups.GroupModal.DeleteModal.Text", {
                  className: this.state.groupToDeleteOrEdit?.name,
                })
              )}
            </div>
          }
          rightButtonText={t("Groups.GroupModal.DeleteModal.Submit")}
          leftButtonText={t("Groups.GroupModal.DeleteModal.Cancel")}
        />

        <UpdateGroupDialog
          users={this.state.users}
          isUpdating={this.state.isUpdating}
          show={this.state.showUpdateGroupModal}
          dialogApiError={this.state.dialogApiError}
          onHide={(isFormDirty) => {
            if (isFormDirty) {
              this.setState({
                dialogApiError: null,
                showUnsavedChangesDialog: true,
                closeAction: () =>
                  this.setState({
                    showUpdateGroupModal: false,
                  }),
              });
            } else {
              this.setState({
                dialogApiError: null,
                showUpdateGroupModal: false,
              });
            }
          }}
          onSubmit={this.handleUpdateGroup}
          class={this.state.groupToDeleteOrEdit}
          userGroupMaps={this.state.userGroupsMap}
        />
        <UnsavedChangesDialog
          show={this.state.showUnsavedChangesDialog}
          onHide={() => this.setState({ showUnsavedChangesDialog: false })}
          onSubmit={() => {
            this.setState({ showUnsavedChangesDialog: false });
            this.state.closeAction();
          }}
        />
        <ShowMembersDialog
          show={this.state.showMembersModal}
          onHide={() => this.setState({ showMembersModal: false })}
          class={this.state.groupToDeleteOrEdit}
          userGroupMaps={this.state.userGroupsMap}
          userMap={this.state.userMap}
        />
        <Container className="mt-3">
          <Row className="pageTitle">
            <Col>
              <h2>{t("Groups.Title")}</h2>
            </Col>
            <Col>
              <div style={{ float: "right" }}>
                <Button
                  className="btn-green ml-3"
                  onClick={() => {
                    this.setState({ showCreateClassModal: true });
                  }}
                >
                  <FontAwesomeIcon icon={faPlus} />
                </Button>
              </div>
            </Col>
          </Row>
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          <Row>
            <Col>
              <PaginationTable
                data={this.state.groups}
                sizePerPage={10}
                paginationSize={3}
                columns={columns}
                keyField="_id"
                ref={this.paginationTableRef}
                id={this.tableId}
                formatExtraData={memberData}
                view="groups"
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(Groups);
